const Ajax = (request) => {
  let req = {
    url: request.url,
    // data 传对象
    data: request.data || {},
    method: (request.method || 'POST').toUpperCase(),
    header: request.header || {},
    callback: request.callback,
    cors: request.cors,
    hash: request.hash
  }
  // query
  if (req.method === 'GET' && Object.keys(req.data).length) {
    req.url += this.query(req.data)
  }
  // hash
  if (req.hash) {
    req.url += req.hash
  }
  // cors
  if (req.cors) {
    req.data.CORS = {
      // 服务器请求地址
      url: req.url,
      // 服务器请求方法
      method: req.method
    }
    req.url = req.cors
    req.method = 'POST'
  }
  // promise
  const res = new Promise((resolve, reject) => {
    let r = new XMLHttpRequest()
    r.open(req.method, req.url, true)
    for (let key in req.header) {
      r.setRequestHeader(key, req.header[key])
    }
    // if (!req.header['Content-Type']) {
    //   r.setRequestHeader('Content-Type', 'application/json')
    // }
    r.onreadystatechange = function() {
      if (r.readyState === 4) {
        let res = r.response
        try {
          res = JSON.parse(res)
        } catch (err) {
          // log('JSON解析错误')
        }
        // 回调函数
        if (typeof req.callback === 'function') {
          req.callback(res)
        }
        // Promise 成功
        resolve(res)
      }
    }
    r.onerror = function(err) {
      reject(err)
    }
    if (req.method === 'GET') {
      r.send()
    } else {
      // POST
      r.send(JSON.stringify(req.data))
    }
  })
  return res
}

export default Ajax
